import { PROPERTY_CREATE_STATE } from 'screens/Property/helpers/constants';

/**
 * Gets selected crop season IDs from localStorage
 * @returns {Array} Array of season IDs or empty array if none found
 */
export const getSeasonIds = () => {
  const selectedCropSeasonsStr = localStorage.getItem('selectedCropSeasons');
  return selectedCropSeasonsStr ? JSON.parse(selectedCropSeasonsStr) : [];
};

/**
 * Gets farm ID from location state or localStorage
 * @param {Object} state - The location state object
 * @returns {string|undefined} Farm ID or undefined
 */
export const getFarmId = state => {
  // First try to get farm ID from state parameter
  const farmIdFromState = state?.selectedId || state?.parentFarm?.id;
  if (farmIdFromState) {
    return farmIdFromState;
  }

  // Fall back to localStorage if state doesn't have farm ID
  const savedState = localStorage.getItem(PROPERTY_CREATE_STATE);
  if (savedState) {
    const parsedState = JSON.parse(savedState);
    return parsedState?.selectedId || parsedState?.parentFarm?.id;
  }

  return undefined;
};
